<template>
  <div class="custom-page">
    <div class="h-full overflow-y-auto">
      <div
        style="
          background: linear-gradient(180deg, #e82035 0%, #ff9964 100%);
          border-radius: 100% 100% 100% 100% / 0% 0% 30% 30%;
        "
        class="pb-32"
      >
        <NavBar
          fixed
          left-arrow
          @click-left="$router.back()"
          style="background: transparent"
          ><template #title>
            <div class="text-white">发红包</div>
          </template></NavBar
        >
      </div>
      <Tabs
        v-model="redpackType"
        class="-mt-24 px-5"
        background="transparent"
        color="#FFE0B6"
      >
        <Tab
          ><template #title
            ><span style="color: #ffe0b6">普通红包</span>
          </template>
        </Tab>
        <Tab title="口令红包"
          ><template #title
            ><span style="color: #ffe0b6">口令红包</span>
          </template></Tab
        >
        <Tab title="指定好友红包"
          ><template #title
            ><span style="color: #ffe0b6">指定好友红包</span>
          </template></Tab
        >
        <div class="box">
          <!-- <div v-if="redpackType == 0" class="flex justify-center text-center">
            <div
              class="rounded mx-2 flex-grow p-2 text-sm"
              :class="!onlyNewFans ? 'yellowOption' : 'grayOption'"
              @click="onlyNewFans = false"
            >
              全部粉丝可领
            </div>
            <div
              class="rounded mx-2 flex-grow p-2 text-sm"
              :class="onlyNewFans ? 'yellowOption' : 'grayOption'"
              @click="onlyNewFans = true"
            >
              新粉丝可领
            </div>
          </div> -->
          <Field
            :disabled="disable"
            v-model="fullAmount"
            type="number"
            label="满"
            placeholder="填写金额"
            input-align="right"
          >
            <template #extra><span class="ml-1">元</span> </template> </Field
          ><Field
            :disabled="disable"
            v-model="reduceAmount"
            type="number"
            label="减"
            placeholder="填写金额"
            input-align="right"
          >
            <template #extra><span class="ml-1">元</span> </template>
          </Field>
        </div>
        <div class="box">
          <Field
            :disabled="disable"
            v-model="redPacketNum"
            type="number"
            label="红包个数"
            placeholder="填写个数"
            input-align="right"
          >
            <template #extra><span class="ml-1">个</span> </template>
          </Field>
        </div>
        <div class="box">
          <Cell
            :disabled="disable"
            title="使用开始时间"
            is-link
            arrow-direction="down"
            :value="startDate.toLocaleString()"
            @click="showStartPicker = true"
          />
          <DatetimePicker
            v-show="showStartPicker && !disable"
            v-model="startDate"
            type="datetime"
            @cancel="
              () => {
                showStartPicker = false;
                startDate = new Date();
              }
            "
            @confirm="showStartPicker = false"
          />
          <Cell
            :disabled="disable"
            title="使用结束时间"
            is-link
            arrow-direction="down"
            :value="endDate.toLocaleString()"
            @click="showEndPicker = true"
          />
          <DatetimePicker
            v-show="showEndPicker && !disable"
            v-model="endDate"
            type="datetime"
            @cancel="
              () => {
                showEndPicker = false;
                endDate = new Date();
              }
            "
            @confirm="showEndPicker = false"
          />
        </div>
        <div class="box">
          <Field
            :disabled="disable"
            v-model="title"
            placeholder="恭喜发财，万事如意"
          />
        </div>
        <div class="font-bold text-4xl text-center">¥{{ totalMoney }}</div>
        <div style="color: #aeaeae" class="text-xs mx-6">
          规定时间内未领取，或领取后未在规定时间内使用
          则红包失效，红包金额讲退回支付账户
        </div>
      </Tabs>
      <Button
        round
        style="
          background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
          width: 80%;
          margin: 1rem 10%;
          height: 40px;
        "
        size="large"
        @click="createRedpack"
        ><span class="text-white">塞钱进红包</span></Button
      >

      <ActionSheet
        v-model="showPayment"
        title="选择付款方式"
        class="font-semibold text-sm"
      >
        <div v-if="paymentChannelList.length" class="content px-5">
          <div
            class="flex justify-between items-center my-3"
            @click="goPay(paymentChannelList[0])"
          >
            <div class="flex items-center">
              <img class="mr-2" src="@/assets/order/余额.svg" alt="" /><span>{{
                paymentChannelList[0].name
              }}</span>
            </div>
            <div>{{ paymentChannelList[0].withdrawAmount + "元" }}</div>
          </div>
          <div style="color: #808080">第三方支付</div>
          <div
            v-for="(channel, index) in paymentChannelList"
            :key="channel.code"
            class="flex justify-between items-center my-3"
            @click="goPay(channel)"
          >
            <div v-if="index" class="flex items-center">
              <img
                v-if="channel.code === 'ALI'"
                class="mr-2"
                src="@/assets/order/支付宝.svg"
                alt=""
              />
              <img
                v-else-if="channel.code === 'WX'"
                class="mr-2"
                src="@/assets/order/微信钱包.svg"
                alt=""
              />
              <img v-else class="mr-2" :src="channel.logo" alt="" /><span>{{
                channel.name
              }}</span>
            </div>
            <div></div>
          </div>
        </div> </ActionSheet
      ><ActionSheet
        v-model="showPasswordInput"
        title="请输入支付密码"
        class="text-sm pb-64"
      >
        <div class="w-full text-center">余额支付</div>
        <div class="w-full text-center text-3xl">￥{{ payAmount }}</div>
        <PasswordInput
          :value="password"
          :focused="showPasswordInput"
          @focus="showPasswordInput = true"
        />
        <!-- 数字键盘 -->
        <NumberKeyboard
          v-model="password"
          :show="showPasswordInput"
          @blur="showPasswordInput = false"
        />
      </ActionSheet>
    </div>
  </div>
</template>

<script>
  import {
    NavBar,
    Tab,
    Tabs,
    Field,
    Cell,
    CellGroup,
    DatetimePicker,
    Button,
    ActionSheet,
    Toast,
    PasswordInput,
    NumberKeyboard,
  } from "vant";
  import { addStoreRedpack } from "./webApi";
  import { getAppId } from "@/api/login";
  import browserType from "@/utils/browserType";
  import browserTypeAdapter from "@/utils/browserTypeAdapter";
  import { getToken } from "@/utils/auth";
  import {
    getPayChannels,
    redpackPay,
    getBillInfo,
    payByBalance,
    payByWxH5,
    payByWxJsapi,
    payByAliH5,
    payPasswordExists,
  } from "@/api/pay";
  export default {
    components: {
      NavBar,
      Tab,
      Tabs,
      Field,
      Cell,
      DatetimePicker,
      Button,
      ActionSheet,
      PasswordInput,
      NumberKeyboard,
    },
    created() {
      this.$store.dispatch("app/showLoading");
      if (this.$route.query.fromWx || this.$route.query.fromAli) {
        this.$store.dispatch("app/hideLoading");
        this.$router.push({ name: "StoreRedpack" });
        // this.showPayConfirm = true;
      } else {
        if (this.$route.query.code) {
          const _this = this;
          payByWxJsapi({
            billId: this.$route.query.billId,
            code: this.$route.query.code,
          })
            .then((res) => {
              // res.data是{appid:...,timestamp:...}
              function onBridgeReady() {
                WeixinJSBridge.invoke(
                  "getBrandWCPayRequest",
                  res.data,
                  function(res) {
                    _this.$store.dispatch("app/hideLoading");
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                      // 使用以上方式判断前端返回,微信团队郑重提示：
                      //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                      Toast({
                        message: "支付完成",
                        position: "center",
                        duration: 1000,
                      });
                      _this.$router.push({ name: "StoreRedpack" });
                    } else {
                      Toast({
                        message: "支付失败",
                        position: "center",
                        duration: 1000,
                      });
                      _this.$router.push({ name: "StoreRedpack" });
                    }
                  }
                );
              }
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener(
                    "WeixinJSBridgeReady",
                    onBridgeReady,
                    false
                  );
                } else if (document.attachEvent) {
                  document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
                  document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
                }
              } else {
                onBridgeReady();
              }
            })
            .catch((e) => {
              this.$store.dispatch("app/hideLoading");
            });
        } else {
          this.$store.dispatch("app/hideLoading");
        }
      }
    },
    data() {
      return {
        browserTypeStr: null,
        redpackType: 0,
        onlyNewFans: false,
        fullAmount: null,
        reduceAmount: null,
        redPacketNum: null,
        startDate: new Date(),
        endDate: new Date(),
        showStartPicker: false,
        showEndPicker: false,
        title: "恭喜发财，万事如意",
        disable: false,
        showPayment: false,
        paymentChannelList: [],
        billId: null,
        payAmount: 0,
        showPasswordInput: false,
        password: "",
      };
    },
    methods: {
      createRedpack() {
        if (!this.fullAmount || !this.reduceAmount || !this.redPacketNum)
          return;
        let storeRedPacketType = null;
        switch (this.redpackType) {
          case 0:
            // if (this.onlyNewFans) {
            //   storeRedPacketType = "NEW_FANS";
            // } else {
            //   storeRedPacketType = "ALL_FANS";
            // }
            storeRedPacketType = "ORDINARY";

            break;
          case 1:
            storeRedPacketType = "COMMAND";

            break;
          case 2:
            storeRedPacketType = "ASSIGN";

            break;

          default:
            break;
        }
        if (this.startDate > this.endDate) {
          const temp = this.startDate;
          this.startDate = this.endDate;
          this.endDate = temp;
        }
        // this.browserTypeStr = localStorage.getItem('browserType') || browserType()

        this.browserTypeStr =
          localStorage.getItem("browserTypeAdapter") || browserTypeAdapter();
        // MARK:
        console.log("browserTypeAdapter");
        console.log(this.browserTypeStr);
        addStoreRedpack({
          fullAmount: this.fullAmount,
          reduceAmount: this.reduceAmount,
          redPacketNum: this.redPacketNum,
          remainNum: this.redPacketNum,
          startDate: this.dayjs(this.startDate).format("YYYY-MM-DD HH:mm:ss"),
          endDate: this.dayjs(this.endDate).format("YYYY-MM-DD HH:mm:ss"),
          storeRedPacketType: storeRedPacketType,
          title: this.title,
        }).then((res) => {
          this.redpackId = res.data;
          getPayChannels().then(({ data }) => {
            this.paymentChannelList = data;
            if (this.browserTypeStr === "miniprogram") {
              this.paymentChannelList = this.paymentChannelList.filter(
                (paymentChannel) => {
                  return !(paymentChannel.code === "ALI");
                }
              );
            }
            this.showPayment = true;
          });
        });
      },
      goPay(channel) {

        if (this.billId && channel.code === "BALANCE") {
          this.showPasswordInput = true;
          return;
        }
        if (channel.available) {
          this.showPayment = false;
          this.$store.dispatch("app/showLoading");
          redpackPay({ targetId: this.redpackId, channel: channel.code })
            .then(({ data }) => {
              this.billId = data;
              this.disable = true;
              getBillInfo(this.billId)
                .then(({ data }) => {
                  this.payAmount = data.amount;
                  if (data.channel === "BALANCE") {
                    payPasswordExists().then(({ data }) => {
                      if (data) {
                        this.showPasswordInput = true;
                        this.payPasswordExist = true;
                      } else {
                        Toast({
                          message: "未设置支付密码",
                          position: "center",
                          duration: 1000,
                        });
                      }
                    });
                  } else if (data.channel === "WX") {
                    this.$store.dispatch("app/showLoading");
                    // MARK:
                    if (this.browserTypeStr === "pc") {
                      console.log("pc");
                      // getAppId()
                      //   .then((res) => {
                      //     this.wechatAuth(res.data);
                      //   })
                      //   .catch(() => {
                      this.$store.dispatch("app/hideLoading");
                      //   });
                    } 
                    else if (this.browserTypeStr === "miniprogram") {
                      const token = getToken();
                      const Authorization = "Bearer " + token;
                      // MARK:
                      // 当前环境是 小程序
                      console.log("miniprogram");
                      // 然后使用 this.wxjs.miniProgram.navigateTo 进行跳转 小程序中的页面
                      //小程序的支付地址
                      console.log(this.wxjs.miniProgram);
                      this.wxjs.miniProgram.navigateTo({
                        url: `../wxpay/wxpay?billId=${this.billId}&Authorization=${Authorization}&isStoreRedpack=true`,
                        success: function(res) {
                          console.log("res success 跳转小程序成功", res);
                        },
                        fail: function(res) {
                          console.log("res fail 跳转失败", res);
                        },
                      });
                    } else if (this.browserTypeStr === "weixin") {
                      console.log("weixin");
                      getAppId()
                        .then((res) => {
                          this.wechatAuth(res.data);
                        })
                        .catch(() => {
                          this.$store.dispatch("app/hideLoading");
                        });
                    } else {
                      console.log("mobile");
                      payByWxH5({ billId: this.billId })
                        .then((res) => {
                          let href =
                            res.data +
                            "&redirect_url=" +
                            encodeURIComponent(
                              window.location.origin +
                                this.$route.path +
                                "?fromWx=true"
                            );
                          // alert(href);
                          window.location.href = href;

                          this.$store.dispatch("app/hideLoading");
                        })
                        .catch((e) => {
                          this.$store.dispatch("app/hideLoading");
                        });
                    }
                  } else if (data.channel === "ALI") {
                    this.$store.dispatch("app/showLoading");

                    if (this.browserTypeStr === "pc") {
                      console.log("pc");
                    } else if (this.browserTypeStr === "weixin") {
                      console.log("weixin");
                      payByAliH5({
                        billId: this.billId,
                        returnUrl:
                          window.location.origin +
                          this.$route.path +
                          "?fromAli=true",
                        quitUrl:
                          window.location.origin +
                          this.$route.path +
                          "?fromAli=true",
                      })
                        .then((res) => {
                          // alert(res.data);
                          var form = res.data;
                          const div = document.createElement("div");
                          div.innerHTML = form;
                          document.body.appendChild(div);
                          document.forms[0].acceptCharset = "utf-8";
                          var queryParam = "";
                          Array.prototype.slice
                            .call(
                              document.querySelectorAll("input[type=hidden]")
                            )
                            .forEach(function(ele) {
                              queryParam +=
                                "&" +
                                ele.name +
                                "=" +
                                encodeURIComponent(ele.value);
                            });
                          var gotoUrl =
                            document
                              .querySelector("form")
                              .getAttribute("action") +
                            "&" +
                            queryParam;
                          _AP.pay(gotoUrl, "StoreRedpack");

                          this.$store.dispatch("app/hideLoading");
                        })
                        .catch((e) => {
                          this.$store.dispatch("app/hideLoading");
                        });
                    } else {
                      console.log("mobile");
                      payByAliH5({
                        billId: this.billId,
                        returnUrl:
                          window.location.origin +
                          this.$route.path +
                          "?fromAli=true",
                        quitUrl:
                          window.location.origin +
                          this.$route.path +
                          "?fromAli=true",
                      })
                        .then((res) => {
                          // alert(res.data);
                          const div = document.createElement("div");

                          div.innerHTML = res.data;
                          document.body.appendChild(div);
                          document.forms[0].submit();

                          this.$store.dispatch("app/hideLoading");
                        })
                        .catch((e) => {
                          this.$store.dispatch("app/hideLoading");
                        });
                    }
                  }
                  this.$store.dispatch("app/hideLoading");
                })
                .catch((e) => {
                  this.$store.dispatch("app/hideLoading");
                });
            })
            .catch((e) => {
              Toast({
                message: "操作失败",
                position: "center",
                duration: 1000,
              });
              this.$store.dispatch("app/hideLoading");
            });
        } else {
          Toast({
            message: channel.reason,
            position: "center",
            duration: 1000,
          });
        }
      },
      wechatAuth(appId) {
        const href =
          window.location.origin +
          this.$route.path +
          "?" +
          this.filterCodeByParams(["billId=" + this.billId]);
        // alert(href);

        const redirect_uri = encodeURIComponent(href);
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
      },
      // 过滤掉 code 参数
      filterCodeByParams(queryList = []) {
        for (const key in this.$route.query) {
          if (Object.hasOwnProperty.call(this.$route.query, key)) {
            if (key !== "code") {
              queryList.push(`${key}=${this.$route.query[key]}`);
            }
          }
        }
        return queryList.join("&");
      },
    },
    computed: {
      totalMoney() {
        return (this.reduceAmount || 0) * (this.redPacketNum || 0);
      },
    },
    watch: {
      password(value) {
        if (value.length === 6) {
          this.$store.dispatch("app/showLoading");
          payByBalance({ billId: this.billId, password: value })
            .then((res) => {
              this.$store.dispatch("app/hideLoading");
              Toast({
                message: res.data ? "支付成功" : "支付失败",
                position: "center",
                duration: 1000,
              });
              this.$router.back();
            })
            .catch((e) => {
              this.password = "";

              this.$store.dispatch("app/hideLoading");
            });
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .custom-page {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    overflow: hidden;
    .van-nav-bar {
      &::after {
        display: none;
      }
      /deep/ .van-nav-bar__content {
        height: 88px;
      }
      /deep/ .van-icon {
        color: #fff;
      }
    }
  }
  .box {
    background-color: white;
    border-radius: 1rem;
    box-shadow: 0rem 0.04rem 0.12rem 0rem rgb(153 153 153 / 30%);
    padding: 0.5rem;
    margin: 1rem 0;
  }
  .yellowOption {
    background-color: #fff3d1;
    color: #fa6400;
  }
  .grayOption {
    background-color: #f4f4f4;
  }
  .van-cell--clickable .van-cell__value {
    min-width: 60% !important;
  }
</style>
